import { Injectable, Inject } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { User } from "../_models/index";

@Injectable()
export class UserService extends HttpService {

    httpService: HttpService;

    constructor(private http: Http, router: Router,
        @Inject(HttpService) _httpService: HttpService) {
        super(http, router);
        this.httpService = _httpService;
    }

    register(postData) {
        var url = "register";
        return this.httpService.httpPost(url, postData);
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/user.service.ts